export class Sizes {
  static xs = 5;
  static s = 10;
  static m = 15;
  static l = 20;
  static xl = 40;
  static xxl = 60;
  static icon = 24;
}
